import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

export default function StatisticCard({ title, text, icon, variant }) {
  return (
    <div className="card card-statistics">
      <div className="card-body">
        <div className="clearfix">
          <div className={ `float-left dashboard-icon text-${variant}` }>
            <FontAwesomeIcon icon={ icon } />
          </div>
          <div className="float-right">
            <p className="mb-0 text-right text-dark">{ title }</p>
            <div className="fluid-container">
              <h3 className="font-weight-medium text-right mb-0 text-dark">
                { text }
              </h3>
            </div>
          </div>
        </div>
        <p className="text-muted mb-0">
          <i className="mr-1" aria-hidden="true"></i>
        </p>
      </div>
    </div>
  );
}
